import ImagePreloader from "image-preloader";
import logger from "./logger";

const preloadImages = [
  // "public/images/anim/animation_correct.gif",
  // "public/images/anim/animation_mistake.gif",
  // "public/images/anim/animation_placeholder.gif",
  // "public/images/anim/answerrate_50.gif",
  // "public/images/anim/answerrate_60-70.gif",
  // "public/images/anim/answerrate_80.gif",
  // "public/images/denjiro_explanation01.png",
  "public/images/denjiro_explanation02.png",
  "public/images/logo.png",
];

class ImageLoader {
  constructor() {
    // https://www.npmjs.com/package/image-preloader
    this.preloader = new ImagePreloader();
    this.loadedImages = [];
  }

  start() {
    return new Promise((resolve, reject) => {
      this.preloader.onProgress = function(info) {
        logger.info(
          "[ImageLoader] image: %s | status: %s",
          info.value.src,
          info.status
        );
      };
      this.preloader
        .preload(preloadImages)
        .then((status) => {
          this.loadedImages = status;
          logger.info("[ImageLoader] all done!", status);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }

  get isLoaded() {
    return (
      this.loadedImages.length == preloadImages.length &&
      this.loadedImages.every(({ status }) => {
        return status;
      })
    );
  }
}

export default new ImageLoader();
